import { companiesRepo } from '@/constants/providers';
import { ApiResponse } from '@/shared/types';
import { useMutation } from '@tanstack/react-query';

export const useDisableCompany = () =>
  useMutation<ApiResponse<unknown>, unknown, number>((id) =>
    companiesRepo.disableCompany(id),
  );
